import React, { ReactNode } from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { withNodeContext } from 'common/builder/controllers/chart/FlowChart/nodes/shared/NodeContext'
import { useFlowFields } from 'common/builder/hooks/useFlowFields'

interface IPersonalizedTextProps {
  children?: ReactNode
  style?: React.CSSProperties
}

const defaultStyle = sharedStyles.text

const PersonalizedText = ({ children, style }: IPersonalizedTextProps) => {
  const fields = useFlowFields()
  const textStyle = style ? { ...defaultStyle, ...style } : defaultStyle
  return <richtext fields={fields} style={textStyle} text={children} />
}

export default withNodeContext(PersonalizedText) as React.FunctionComponent<IPersonalizedTextProps>
